import Vue from 'vue'
import Router from 'vue-router'
import homePage from '@/views/Homepage'
import authentication from '@/views/Authentication'
import myOrder from '@/views/MyOrder'
// import changeTicket from '@/views/ChangeTicket'
import login from '@/views/Login'
import registered from '@/views/Registered'
import setPassword from '@/views/SetPassword'
import error from '@/views/Error'
import others from '@/views/Others'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '/',
      redirect: "/homePage"
    }, // 主页
    {
      path: '/homePage',
      name: 'Homepage',
      component: homePage
    }, // 主页
    {
      path: '/authentication',
      name: 'Authentication',
      component: authentication,
      meta: { auth: true }
    }, // 实名认证  
    {
      path: '/myOrder',
      name: 'MyOrder',
      component: myOrder,
      meta: { auth: true }
    }, // 我的订单
    // {
    //   path: '/changeTicket',
    //   name: 'ChangeTicket',
    //   component: changeTicket,
    //   meta: { auth: true }
    // }, // 改签
    {
      path: '/login',
      name: 'Login',
      component: login
    }, // 登录                                     
    {
      path: '/registered',
      name: 'Registered',
      component: registered
    }, // 注册                                   
    {
      path: '/setPassword',
      name: 'SetPassword',
      component: setPassword
    }, // 找回密码
    {
      path: '*',
      name: 'Error',
      component: error
    }, // 404   
    {
        path: '/others',
        name: 'Others',
        component: others
    }, // 系统维护升级中...    
      
    // {
    //     path: '/suggestions',
    //     name: 'Suggestions',
    //     component: () => import('@/views/Suggestions')
    // }, // 投诉建议 
    {
        path: '/parkingSpace',
        name: 'ParkingSpace',
        component: () => import('@/views/ParkingSpace')
    }, // 预约车位 
    {
        path: '/parkingSuccess',
        name: 'ParkingSuccess',
        component: () => import('@/views/ParkingSuccess')
    }, // 预约成功
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js